import { render, staticRenderFns } from "./newAttribute.vue?vue&type=template&id=698a99a8&scoped=true"
import script from "./newAttribute.vue?vue&type=script&scoped=true&lang=js"
export * from "./newAttribute.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./newAttribute.vue?vue&type=style&index=0&id=698a99a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a99a8",
  null
  
)

export default component.exports